// Local translations
export const T = {
  en_GB: {
    user: "User",
    org: "Org",
    profile: "Profile",
    notifications: "Notifications",
    security: "Security",
    loggingOut: "Logging out...",
    logOut: "Log out",
  },
  nb_NO: {
    user: "Bruker",
    org: "Org",
    profile: "Profil",
    notifications: "Varsler",
    security: "Sikkerhet",
    loggingOut: "Logger ut...",
    logOut: "Logg ut",
  },
} as const;
